import React from 'react';

const Footer = ({ buildVersion, containerName, buildDate }) => {

  return (
    <footer className="footer" style={{ color: "#00a8ff" }}>
      <div className="center">
        <p>
          Build Version: {buildVersion} | {containerName} | 
          Latest Update (CET): {buildDate}
        </p>
      </div>
    </footer>
  );
};

export default Footer;